<main class="support-page" role="main">
	<div class="support-card">
		<h1 class="support-title">{{ 'Support_Title' | translate }}</h1>
		<p class="support-desc">{{ 'Support_Description' | translate }}</p>

		<div class="contact-list">
			<div class="contact-item">
				<span class="contact-icon" aria-hidden="true">
					<!-- Simple email icon -->
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" role="img">
						<path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 2v.01L12 13L4 6.01V6h16ZM4 8.25l8 6l8-6V18H4V8.25Z"/>
					</svg>
				</span>
				<div class="contact-text">
					  <div class="label">{{ 'Support_Email' | translate }}</div>
					<a class="value" href="mailto:support@alfaservices.net">support@alfaservices.net</a>
				</div>
			</div>

			<div class="contact-item">
				<span class="contact-icon" aria-hidden="true">
					<!-- Simple WhatsApp icon -->
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" role="img">
						<path d="M12 2a10 10 0 0 0-8.66 15.29L2 22l4.86-1.28A10 10 0 1 0 12 2Zm0 2a8 8 0 0 1 6.86 12.32l-.24.37A8 8 0 0 1 6.4 18.4l-.37-.24A8 8 0 0 1 12 4Zm-3.9 3.6c.2-.04.41 0 .58.14l1.09 1.09c.19.19.24.47.12.71l-.56 1.12c-.06.12-.04.26.05.36c.75.94 1.69 1.7 2.74 2.25c.12.06.26.05.37-.04l1.08-.86c.23-.18.56-.16.76.04l1.09 1.09c.19.19.23.49.1.72c-.47.85-1.14 1.52-1.99 1.99c-.37.2-.81.2-1.2.04c-2.06-.86-3.8-2.29-4.99-4.16c-.2-.32-.26-.72-.17-1.09c.14-.58.47-1.11.93-1.57c.14-.14.31-.25.5-.29Z"/>
					</svg>
				</span>
				<div class="contact-text">
					  <div class="label">{{ 'Support_WhatsApp' | translate }}</div>
					<a class="value" href="https://wa.me/+420723454349" target="_blank" rel="noopener">+420 723 454 349</a>
				</div>
			</div>
		</div>
	</div>
</main>
